import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import UploadPGN from './UploadPGN';
import UploadRecords from './GameImportRecords';
import FIDEPGNImport from './features/games/FIDEPGNImport'

export default function Contribute(props) {
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [idType, setIdType] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("FIDE")) {
                    setIsPlayer(true);
                    setIdType("FIDE");
                    setPlayerId(user.sub.replace("FIDE", ""));
                } else if (user.sub.includes("Affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("USCF")) {
                    setIsPlayer(true);
                    setIdType("USCF");
                    setPlayerId(user.sub.replace("USCF", ""));
                }

                setUserRole(role);
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }
        }
        fetchData();
        },[]);

        return (
            <div>
                {authenticated &&
                    <UploadPGN />
                }
                {isAdmin &&
                    <UploadRecords />
                }
                {isAdmin &&
                    <FIDEPGNImport/>
                }
            </div>
        );
}
